import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import {
	triggerFetchKycStatusApiCall,
	triggerFetchKycStatusApiCallSuccess,
	triggerHomeDetailsApiCall,
	triggerHomeDetailsApiCallSuccess,
} from 'redux/actions';
import { TRIGGER_FETCH_KYC_STATUS_API } from 'redux/actionTypes';
import store from 'redux/store';
import { apiCall } from 'services';
import { CleverTapEvent, CleverTapEventNames, nativeHandler } from 'utils';

function* triggerFetchKycStatusSagaCall(actions) {
	const { data, callback } = actions;
	const DONT_OPEN_DEEPLINK = data?.['dontOpenDeeplink'];
	const HAS_CALLBACK = data?.['hasCallback'];
	const CALLBACK_URL = encodeURIComponent('');
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.KYC_STATUS + API_CONSTANT.QUERY_PARAMS.CALLBACK_URL + CALLBACK_URL,
		method: 'GET',
		options: {
			dontRemoveLoader: true,
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		yield put(triggerFetchKycStatusApiCallSuccess(apiData));
		yield put(triggerHomeDetailsApiCallSuccess(apiData));
		if (DONT_OPEN_DEEPLINK) {
			nativeHandler.removeLoader();
			HAS_CALLBACK && callback && callback(apiData);
		} else {
			if (apiData?.callbackUrl) {
				nativeHandler.openDeepLinkWithCallback(apiData?.callbackUrl, () => {
					nativeHandler.removeLoader();
					if (
						!store.getState().homeDetails.postPaidAccount?.agreement ||
						!store.getState().homeDetails.prePaidAccount?.agreement
					) {
						store.dispatch(
							triggerFetchKycStatusApiCall(
								{
									dontOpenDeeplink: true,
									hasCallback: true,
								},
								(data) => {
									if (data?.kycLevel !== 2) {
										store.getState().homeDetails?.accountStatus !== 'PREACTIVE' && nativeHandler.closeWebView();
									} else {
										CleverTapEvent.send(CleverTapEventNames.EVENTS_NAME.MANDATORY_EVENTS.KYC_VERIFIED);
										store.dispatch(
											triggerHomeDetailsApiCall({
												fireEligibilityEvent: true,
											}),
										);
									}
								},
							),
						);
					} else {
						callback && callback(apiData);
					}
				});
			}
		}
	}
}

export default function* triggerFetchKycStatusApiCallSaga() {
	yield takeEvery(TRIGGER_FETCH_KYC_STATUS_API, triggerFetchKycStatusSagaCall);
}
